<template>
    <div class="OrderAddress-root">
        <!-- <info-box :show-line="false" title="线路及货品" /> -->
        <block-title
            v-if="needTransport || orderDetail.startStationName"
            title="发货地信息"
            class="origin-station"
            :show-line="false"
            icon-title="发"
        >
            <div class="station-info">
                <div>
                    <h3 class="station-name">{{orderDetail.startStationName || '--'}}</h3>
                </div>
                <div v-if="needTransport" class="station-container flex">
                    <div class="station-contact">
                        <img src="@/assets/img/contacts.png" alt="">
                        <template v-if="orderDetail.ext && orderDetail.ext.demoData">
                            {{orderDetail.orderMsgResList[0].consignorName.slice(0,1)+'**'}}
                            {{consignorTel}}
                        </template>
                        <template v-else>
                            {{orderDetail.orderMsgResList[0].consignorName}} {{orderDetail.orderMsgResList[0].consignorTel}}
                        </template>
                    </div>
                    <div class="station-address">
                        <img src="@/assets/img/addrress_icon.png" alt="">
                        {{
                            orderDetail.orderMsgResList[0].consignorProvinceName +
                            orderDetail.orderMsgResList[0].consignorCityName +
                            orderDetail.orderMsgResList[0].consignorCountyName +
                            orderDetail.orderMsgResList[0].consignorAddress
                        }}
                    </div>
                    <div v-if="orderDetail.startTime" class="station-time">
                        <img src="@/assets/img/tips_icon.png" alt="">
                        要求取货时间 {{orderDetail.orderMsgResList[0].startTime | formatTimestamp}}
                    </div>
                </div>
            </div>
        </block-title>
        <block-title
            v-if="needTransport || orderDetail.endStationName"
            title="收货地信息"
            class="end-station"
            :show-line="false"
            icon-title="收"
        >
            <!-- <span slot="icon-right" class="icon-show" @click="onEndShow">
                {{endShow ? '收起' : '展开'}}
                <a-icon v-if="endShow" type="caret-up" />
                <a-icon v-else type="caret-down" />
            </span> -->
            <div v-if="endShow">
                <div
                    v-for="(item, index) in endStation"
                    :key="index"
                    class="station-info"
                >
                    <div class="station-status flex">
                        <h3 class="station-name">{{item.stationName || '--'}}</h3>
                    </div>
                    <div  class="station-container flex">
                        <div class="station-contact">
                            <img src="@/assets/img/contacts.png" alt="">
                            {{item.recipientName || ''}} {{item.recipientTel || ''}}
                        </div>
                        <div class="station-address">
                            <img src="@/assets/img/addrress_icon.png" alt="">
                            {{item.recipientProvinceName + item.recipientCityName + item.recipientCountyName + item.recipientAddress}}
                        </div>
                        <div class="station-time">
                            <img src="@/assets/img/tips_icon.png" alt="">
                            期望送达时间 {{item.reachTime | formatTimestamp}}
                        </div>
                        <div v-show="orderDetail.status!==STATUSTEXT.DRAFT&&item.wmsOdrNo" class="wharehouse-no">
                            关联仓库单号 {{item.wmsOdrNo}}
                        </div>
                    </div>
                    <span class="icon-change" @click="changeShow(index)">
                        {{!goodShowList[index] ? '收起' : '展开'}}
                        <a-icon v-if="goodShowList[index]" type="caret-down" />
                        <a-icon v-else type="caret-up" />
                    </span>
                    <div v-if="!goodShowList[index]" class="station-orders">
                        <div v-if="needTransport" class="order-info">
                            <div class="flex">
                                <div class="flex order-info-container">
                                    <div class="info-order">
                                        <p>子单号：<span>{{item.odrNo}}</span></p>
                                    </div>
                                    <div class="info-order">
                                        <p>发货地：<span>{{orderDetail.startStationName}}</span></p>
                                    </div>
                                </div>
                                <div class="order-info-container staus-container">
                                    <p>状态：<span>{{OrderStatus[item.status]}}</span></p>
                                </div>
                            </div>
                            <div class="flex action-button">
                                <a-tooltip
                                    v-if="(showEditStatus.includes(`${item.status}`) && (!item.upAddType || item.upAddType === 1))"
                                    title="同一个订单只允许申请一次收货地变更，请仔细核对信息"
                                >
                                    <a-button
                                        icon="edit"
                                        @click="editAddress(item)"
                                    >
                                        修改收货地址
                                    </a-button>
                                </a-tooltip>
                                <!-- 订单站点修改审核通过并且处理成功 -->
                                <div v-if="(item.upAddType === 2)">
                                    <span class="tag">已改收货地址</span>
                                    <a-button
                                        type="link"
                                        @click="detailAddress(item)"
                                    >
                                        查看原地址<a-icon type="right" />
                                    </a-button>
                                </div>
                                 <a-button
                                    v-if="(!orderDetail.ext || !orderDetail.ext.demoData) && orderDetail.negotiationType !== NEGOTIABLE && [D_STATUS.TO_BE_SUBMITTED, D_STATUS.TO_BE_DISPATCH, D_STATUS.ABNORMAL].includes(item.status)"
                                    @click="cancelOrder(item)"
                                >
                                    取消订单
                                </a-button>
                            </div>
                        </div>
                        <template v-if="orderDetail.needTransport&&orderDetail.isWarehouseMultiDischargeOrder">
                           <address-goods
                            :index="index"
                            :goods-table="goodsTable"
                            :goods-list="item.goodsList"
                        />
                        </template>
                        <template v-else>
                           <address-goods
                            :goods-table="goodsTable"
                            :goods-list="goodsList()"
                        />
                        </template>
                    </div>
                </div>
            </div>
        </block-title>
        <div v-else class="single-goods">
            <div class="station-orders">
                <address-goods
                    :goods-table="goodsTable"
                    :goods-list="goodsList()"
                />
            </div>
        </div>
        <edit-address ref="editAddress" @success="editSuccess" />
        <original-address ref="originalAddress" />
    </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
// import InfoBox from './InfoBox.vue'
import { cancelFullOrder } from '@/pages/orderManage/api';
import {STATUSTEXT} from '../../warehouseList/constant.js'
import AddressGoods from './AddressGoods.vue';
import {OrderStatus, OrderStatusCode,D_STATUS,NEGOTIABLE} from '../../../orderManage/constant'
import EditAddress from './EditAddress.vue'
import OriginalAddress from './OriginalAddress.vue'

const TypeList = {
    OUT: 1, // 出库
    IN: 2, // 入库
    DIAO: 3, // 调拨
}

export default {
    name: 'OrderAddress',
    components: {
        // InfoBox,
        BlockTitle,
        AddressGoods,
        EditAddress,
        OriginalAddress,
    },
    props: {
        orderDetail: {
            type: Object,
            default: () => ({})
        },
        warehouseType: {
            type: Number,
            default: 1
        }
    },
    data () {
        const goodsTableIn = [
            {
                title: '货品',
                dataIndex: 'skuName',
                key: 'skuName',
                width: 200,
                customRender: (value, row) => {
                return {
                    children: value || '--',
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            {
                title: '温区',
                dataIndex: 'temperatureZone',
                key: 'temperatureZone',
                width: 100,
                customRender: (value, row) => {
                return {
                    children: value || '--',
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            // {
            //     title: '指定批次',
            //     dataIndex: 'stockBatch',
            //     key: 'stockBatch',
            //     width: 100,
            //     customRender: (val) => val || '--'
            // },
            {
                title: '计划量',
                dataIndex: 'plan',
                key: 'plan',
                scopedSlots: { customRender: 'plan' },
                width: 180,
                customRender: (value, row) => {
                return {
                    children: (
                        <div>
                        <p>共{row.planAmount || 0}{row.skuUnit}</p>
                        <p>共{row.planWeight || 0}kg/{row.planVolume || 0}M³</p>
                        </div>
                    ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            {
                title: '入库量',
                dataIndex: 'deliver',
                key: 'deliver',
                scopedSlots: { customRender: 'deliver' },
                width: 180,
                customRender: (value, row) => {
                    let ele = <div>--</div>
                    if (row.storeFinishSum) {
                        ele = <div>
                            <p>共{row.storeFinishSum || 0}{row.skuUnit}</p>

                            </div>
                    }
                return {
                    children: (
                        ele
                    ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
        ]
        const goodsTableColums = [
        {
            title: '货品',
            dataIndex: 'goodsName',
            key: 'goodsName',
            width: 200,
            customRender: (value, row) => {
            return {
                children: value || '--',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
            },
        },
        {
            title: '温区',
            dataIndex: 'temperatureZone',
            key: 'temperatureZone',
            width: 100,
            customRender: (value, row) => {
            return {
                children: value || '--',
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
            },
        },
        {
            title: '指定批次',
            dataIndex: 'stockBatch',
            key: 'stockBatch',
            width: 200,
            customRender: (val, row) => {
              if(this.orderDetail.odrChannel === 14){
                return val || '--'
              }
              const batchAttr = row?.batchAttr[0]
              if(batchAttr) {
                return `${batchAttr?.attrName}(${batchAttr?.attrValue})`
              }
              return  '--'
            }
        },
        {
            title: '计划量',
            dataIndex: 'plan',
            key: 'plan',
            scopedSlots: { customRender: 'plan' },
            width: 180,
            customRender: (value, row) => {
            return {
                children: (
                    <div>
                      <p>共{row.planAmount || 0}{row.skuUnit}</p>
                      <p>共{row.planWeight || 0}kg/{row.planVolume || 0}M³</p>
                    </div>
                  ),
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
            },
        },
        {
            title: '出库量',
            dataIndex: 'deliver',
            key: 'deliver',
            scopedSlots: { customRender: 'deliver' },
            width: 180,
            customRender: (value, row) => {
                let ele = <div>--</div>
                if (row.deliverFinishSum) {
                    ele = <div>
                    <p>共{row.deliverFinishSum || 0}{row.skuUnit}</p>

                    </div>
                }
            return {
                children: (
                    ele
                  ),
                attrs: {
                    rowSpan: row.rowSpan,
                },
            };
            },
        },
        {
            title: '拒收量',
            dataIndex: 'refuse',
            width: 180,
            customRender: (value, row) => {
                let ele = <div>--</div>
                if (row.refuseWeight) {
                    ele = <div>
                            <p>共{row.refuseSum || 0}{row.skuUnit}</p>
                            <p>共{row.refuseWeight || 0}kg/{row.refuseVolume || 0}M³</p>
                        </div>
                }
                return {
                    children: (
                        ele
                    ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
              };
            },
        },
        ]
        const goodsTableColumsUN = [
            {
                title: '货品',
                dataIndex: 'goodsName',
                key: 'goodsName',
                width: 200,
                customRender: (value, row) => {
                return {
                    children: value || '--',
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            {
                title: '温区',
                dataIndex: 'temperatureZone',
                key: 'temperatureZone',
                width: 100,
                customRender: (value, row) => {
                return {
                    children: value || '--',
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            {
                title: '指定批次',
                dataIndex: 'stockBatch',
                key: 'stockBatch',
                width: 100,
                customRender: (val) => val || '--'
            },
            {
                title: '计划量',
                dataIndex: 'plan',
                key: 'plan',
                scopedSlots: { customRender: 'plan' },
                width: 180,
                customRender: (value, row) => {
                return {
                    children: (
                    <div>
                      <p>共{row.planAmount || 0}{row.skuUnit}</p>
                      <p>共{row.planWeight || 0}kg/{row.planVolume || 0}M³</p>
                    </div>
                  ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            {
                title: '出库量',
                dataIndex: 'deliver',
                key: 'deliver',
                scopedSlots: { customRender: 'deliver' },
                width: 180,
                customRender: (value, row) => {
                    let ele = <div>--</div>
                    if (row.deliverFinishSum) {
                        ele = <div>
                        <p>共{row.deliverFinishSum || 0}{row.skuUnit}</p>
                        </div>
                    }
                return {
                    children: (
                        ele
                    ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            {
                title: '入库量',
                dataIndex: 'store',
                key: 'store',
                scopedSlots: { customRender: 'store' },
                width: 180,
                customRender: (value, row) => {
                    let ele = <div>--</div>
                    if (row.storeFinishSum) {
                        ele = <div>
                            <p>共{row.storeFinishSum || 0}{row.skuUnit}</p>

                            </div>
                    }
                return {
                    children: (
                        ele
                      ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            },
            ]
        const signFor = {
                title: '签收量',
                dataIndex: 'sign',
                key: 'sign',
                scopedSlots: { customRender: 'sign' },
                width: 180,
                customRender: (value, row) => {
                    let ele = <div>--</div>
                    if(row.signWeight   ) {
                        ele = <div>
                            <p>共{row.signSum || 0}{row.skuUnit}</p>
                            <p>共{row.signWeight || 0}kg/{row.signVolume || 0}M³</p>
                        </div>
                    }
                return {
                    children:
                      (
                        ele
                      ),
                    attrs: {
                        rowSpan: row.rowSpan,
                    },
                };
                },
            }
            // const overColums = {
            //     title: '是否越库',
            //     dataIndex: 'isOverWarehouse',
            //     key: 'isOverWarehouse',
            //     width: 100,
            //     customRender: (value) => value ? '是' : '否'
            // }

        return {
            NEGOTIABLE,
            D_STATUS,
            goodsTableIn,
            goodsTableColums,
            goodsTableColumsUN,
            signFor,
            // overColums,
            STATUSTEXT,
            endShow: true,
            goodShowList: [],
            OrderStatus,
            // D订单状态=“待处理”or“待派车”or“待提货”or“运输中”，
            showEditStatus: [
                // OrderStatusCode.TO_BE_SUBMITTED.val,
                OrderStatusCode.TO_BE_DISPATCH.val,
                OrderStatusCode.TO_BE_START.val,
                OrderStatusCode.TO_BE_SIGN.val,
                OrderStatusCode.PART_SIGN.val
            ]
        }
    },
    computed: {
        consignorTel() {
            const {consignorTel } = this.orderDetail.orderMsgResList[0] || {};
            return `${consignorTel.slice(0, 3)}****${consignorTel.slice(consignorTel.length-4,consignorTel.length)}`
        },
        getEndStatation() {
            if(this.orderDetail?.ext?.endStation){
                const {provinceName, cityName, countyName,address} = this.orderDetail?.ext?.endStation[0] || {}
                return `${provinceName || ''}${cityName || ''}${countyName || ''}${address|| ''}`
            }
            return ''
        },
        getStartStatation() {
            if(this.orderDetail?.ext?.startStation){
                const {provinceName, cityName, countyName,address} = this.orderDetail?.ext?.startStation || {}
                return `${provinceName || ''}${cityName || ''}${countyName || ''}${address|| ''}`
            }
            return ''
        },
        endStation() {
            if(this.orderDetail.needTransport&&this.orderDetail.isWarehouseMultiDischargeOrder){
              return this.orderDetail.orderMsgResList.map(item=>({
                ...item.orderStationList[0],
                status:item.status,
                upAddType: item.ext?.upAddType,
                wmsOdrNo:this.getWmsNo(item.orderStationList[0].stationCode),
                goodsList:this.goodsList(item.orderStationList[0].stationCode,item.orderGoodsList)
            }))
            }if(!this.orderDetail.needTransport){
               return [{
                    stationId: this.orderDetail.endStationId || '',
                    recipientName: this.orderDetail.endStationContact || '',
                    recipientTel: this.orderDetail.endStationContactPhone || '',
                    reachTime: this.orderDetail.endTime,
                    provinceCode: this.orderDetail.ext?.endStation?.[0]?.provinceCode,
                    cityCode: this.orderDetail.ext?.endStation?.[0]?.cityCode,
                    countyCode: this.orderDetail.ext?.endStation?.[0]?.countyCode,
                    recipientProvinceName: this.orderDetail.ext?.endStation?.[0]?.provinceName,
                    recipientCityName: this.orderDetail.ext?.endStation?.[0]?.cityName,
                    stationName: this.orderDetail.endStationName,
                    recipientAddress:this.orderDetail.ext?.endStation?.[0]?.address,
                    recipientCountyName: this.orderDetail.ext?.endStation?.[0]?.countyName,
                    wmsOdrNo:''
               }]
            }
            if (this.orderDetail.orderMsgResList?.[0].orderStationList) {
                return this.orderDetail.orderMsgResList.map(item => ({
                    ...item.orderStationList[0],
                    status: item.status,
                    upAddType: item.ext?.upAddType,
                }))
            }
            return [{}]

        },
        // 目的地信息
        destinationInfo() {
            if (!this.orderDetail.orderMsgResList[0].orderStationList) return {}
            const station = this.orderDetail.orderMsgResList[0].orderStationList[0]
            return {
                recipientName: this.orderDetail.ext?.demoData ? `${station.recipientName.slice(0, 1)}**` : station.recipientName,
                recipientTel: this.orderDetail.ext?.demoData? `${station.recipientTel.slice(0, 3)}****${station.recipientTel.slice(station.recipientTel.length-4,station.recipientTel.length)}` : station.recipientTel,
                recipientProvinceName: station.recipientProvinceName,
                recipientCityName: station.recipientCityName,
                recipientCountyName: station.recipientCountyName,
                recipientAddress: station.recipientAddress,
                reachTime: this.orderDetail.orderMsgResList[0].reachTime,
                odrNo: station.odrNo
            }
        },
        goodsList() {
            return (stationCode='',orderGoodsList=[])=>{
              if (!this.orderDetail.unifyOrderGoodsList) return []
              let data=[];
              if(this.orderDetail.needTransport&&this.orderDetail.isWarehouseMultiDischargeOrder){
                data=this.multiDischargeGoods(stationCode,'skuId',orderGoodsList)
              }else{
                data = this.concatList('skuId')
              }
            const tableList = []
            data.forEach((res) => {
                if(res.childrens.length > 1){
                    res.childrens.forEach((e, i, arr) => {
                        if(i === 0){
                            const ext = e.wmsExt || {}
                            let refuseSum = 0;
                            let refuseWeight = 0;
                            let refuseVolume = 0;
                            let storeFinishSum = 0;
                            let storeFinishWeight = 0;
                            let storeFinishVolume = 0;
                            let deliverFinishSum = 0;
                            let deliverFinishWeight = 0;
                            let deliverFinishVolume = 0;
                            let signSum = 0;
                            let signWeight = 0;
                            let signVolume = 0;
                            let planAmount = 0;
                            let planVolume = 0;
                            let planWeight = 0;
                            if(res.childrens.length > 1){
                                res.childrens.forEach((n) => {
                                    // Object.keys(n.wmsExt).forEach((m)=>{
                                    //     ext[m] += n.wmsExt[m]
                                    //     ext[m] = parseFloat(ext[m].toFixed(3))
                                    // })
                                    const goodExt = n.wmsExt || {};
                                    refuseSum += goodExt.refuse_sum || 0;
                                    refuseWeight += goodExt.refuse_weight || 0;
                                    refuseVolume += goodExt.refuse_volume || 0;
                                    storeFinishSum += goodExt.store_finish_sum || 0;
                                    storeFinishWeight += goodExt.store_finish_weight || 0;
                                    storeFinishVolume += goodExt.store_finish_volume || 0;
                                    deliverFinishSum += goodExt.deliver_finish_sum || 0;
                                    deliverFinishWeight += goodExt.deliver_finish_weight || 0;
                                    deliverFinishVolume += goodExt.deliver_finish_volume || 0;
                                    signSum += goodExt.sign_sum || 0;
                                    signWeight += goodExt.sign_weight || 0;
                                    signVolume += goodExt.sign_volume || 0;
                                    planAmount += n.planAmount || 0;
                                    planVolume += n.planVolume || 0;
                                    planWeight += n.planWeight || 0;
                                })
                            }
                            tableList.push({
                                ...e,
                                ...ext,
                                goodsName: e.skuName,
                                key: e.id,
                                skuValue: e.skuValue || '--',
                                goodsInfo: {
                                    skuSum: e.skuSum,
                                    skuUnit: e.ext?.goodsUnit,
                                    weightTon: e.weightTon,
                                    volume: e.volume
                                },
                                skuUnit: e.skuUnit,
                                refuseSum,
                                refuseWeight,
                                refuseVolume,
                                storeFinishSum,
                                storeFinishWeight,
                                storeFinishVolume,
                                deliverFinishSum,
                                deliverFinishWeight,
                                deliverFinishVolume,
                                signSum,
                                signWeight: signWeight.toFixed(3),
                                signVolume: signVolume.toFixed(3),
                                planAmount: planAmount.toFixed(3),
                                planVolume: planVolume.toFixed(3),
                                planWeight: planWeight.toFixed(3),
                                rowSpan: arr.length
                            })
                        }else{
                            tableList.push({
                                ...e,
                                ...e.wmsExt,
                                goodsName: e.skuName,
                                key: e.id,
                                skuValue: e.skuValue || '--',
                                goodsInfo: {
                                    skuSum: e.skuSum,
                                    skuUnit: e.ext?.goodsUnit,
                                    weightTon: e.weightTon,
                                    volume: e.volume
                                },
                                rowSpan: 0
                            })
                        }
                    })
                }else{
                    const goodExt = res.wmsExt || {};
                    tableList.push({
                        ...res,
                        ...res.wmsExt,
                        goodsName: res.skuName,
                        key: res.id,
                        skuValue: res.skuValue || '--',
                        goodsInfo: {
                            skuSum: res.skuSum,
                            skuUnit: res.ext?.goodsUnit,
                            weightTon: res.weightTon,
                            volume: res.volume
                        },
                        refuseSum: goodExt.refuse_sum || 0,
                        refuseWeight: goodExt.refuse_weight || 0,
                        refuseVolume: goodExt.refuse_volume || 0,
                        storeFinishSum: goodExt.store_finish_sum || 0,
                        storeFinishWeight: goodExt.store_finish_weight || 0,
                        storeFinishVolume: goodExt.store_finish_volume || 0,
                        deliverFinishSum: goodExt.deliver_finish_sum || 0,
                        deliverFinishWeight: goodExt.deliver_finish_weight || 0,
                        deliverFinishVolume: goodExt.deliver_finish_volume || 0,
                        signSum: goodExt.sign_sum || 0,
                        signWeight: goodExt.sign_weight || 0,
                        signVolume: goodExt.sign_volume || 0,
                        planAmount: res.planAmount || 0,
                        planVolume: res.planVolume || 0,
                        planWeight: res.planWeight || 0,
                        rowSpan: 1,
                    })
                }
            })
            return tableList
            }
        },
        goodsTable(){
            let tableList = []
            if(this.warehouseType === TypeList.OUT){
                tableList = this.goodsTableColums
            }
            if(this.warehouseType === TypeList.IN){
                tableList = this.goodsTableIn
            }
            if(this.warehouseType === TypeList.DIAO){
                tableList = this.goodsTableColumsUN
            }
            if(this.orderDetail.needTransport){
                tableList.push(this.signFor)
            }
            // tableList.push(this.overColums)
            return tableList
        },
        needTransport() {
            return this.orderDetail.orderMsgResList && this.orderDetail.orderMsgResList.length > 0
        }
    },
    mounted () {},
    methods: {
        editSuccess() {
            this.$emit('change')
        },
        // 修改收货地址
        editAddress(row) {
            this.$refs.editAddress.onShow(row)
        },
        // 记录详情
        detailAddress(row) {
            this.$refs.originalAddress.onShow(row)
        },
        onEndShow() {
            this.endShow = !this.endShow
        },
        changeShow(index) {
            const show = this.goodShowList[index]
            this.$set(this.goodShowList, [index],  !show)
        },
        getWmsNo(stationCode){
          return this.orderDetail.warehouseOrderResList.find(item=>item.stationCode===stationCode).wmsOdrNo
        },
        multiDischargeGoods(stationCode,calcId,orderGoodsList){
            const goodsList = [];
            const sameIds = [];
            const stationGoods=this.orderDetail.warehouseOrderResList.find(item=>item.stationCode===stationCode)
            stationGoods.warehouseOrderGoodsList.forEach((item) => {
                const keyList = sameIds.map((e)=>{
                    return e.skuId
                })
                const index = keyList.indexOf(item[calcId]);
                if (index > -1 && sameIds[index].skuUnit === item.skuUnit) {
                    goodsList[index].childrens.push(item);
                } else {
                    sameIds.push(item);
                    const goods=orderGoodsList.find(g=>g.skuId===item.skuId)
                    goodsList.push({
                        ...item,
                        wmsExt:{
                          ...item.wmsExt,
                          deliver_finish_sum:item.finishAmount,
                          sign_sum:goods.finishSum,
                          sign_weight:goods.finishWeight,
                          sign_volume:goods.finishVolume,
                        },
                        childrens: [item],
                    });
                }
            });
            return goodsList;
        },
        concatList(calcId){
            const goodsList = [];
            const sameIds = [];
            this.orderDetail.unifyOrderGoodsList.forEach((item) => {
                const keyList = sameIds.map((e)=>{
                    return e.skuId
                })
                const index = keyList.indexOf(item[calcId]);
                if (index > -1 && sameIds[index].skuUnit === item.skuUnit) {
                    goodsList[index].childrens.push(item);
                } else {
                    sameIds.push(item);
                    goodsList.push({
                        ...item,
                        childrens: [item],
                    });
                }
            });
            return goodsList;
        },
        cancelOrder(station) {
            this.$confirm({
                content: `确认取消【目的地：${station.fullAddress}】的子订单?`,
                confirmLoading: false,
                onOk: () => {
                    return new Promise((resolve) => {
                        cancelFullOrder({
                            odrNos: [station.odrNo],
                            reason: '货主端取消',
                        }).then(() => {
                            this.$message.success('取消成功')
                            resolve()
                            setTimeout(() => {
                                this.$emit('cancel')
                            }, 1000);
                        }).catch(() => {
                            resolve()
                        })
                    })
                }
            })
        },
        // rowClass(record) {
        //     return `rowSpan${record.skuId}`;
        // },
        // customRow() {
        //     return {
        //         on: {
        //             mouseenter: (event) => {
        //                 this.mouseAction(event, 'add');
        //             },
        //             mouseleave: (event) => {
        //                 this.mouseAction(event, 'remove');

        //             },
        //         }
        //     };
        // },
        // mouseAction(event, type) {
        //     const { classList } = event.target;
        //     let currentClass = '';
        //     for (let i = 0; i < classList.length; i+=1) {
        //         if (/rowSpan+/.test(classList[i])) {
        //         currentClass = classList[i];
        //         break;
        //         }
        //     }
        //     const eles = document.getElementsByClassName(currentClass);
        //     for (let i = 0; i < eles.length; i+=1) {
        //         eles[i].classList[type]('ant-table-row-hover');
        //     }
        // },
    },
}
</script>
<style lang="less" scoped>
.OrderAddress-root {
    // background: #fff;
    // padding-bottom: 32px;
    .block-title {
        background: #fff;
        padding: 24px;
        ::v-deep .label {
            margin-bottom: 16px;
        }
    }
    .flex {
        display: flex;
        align-items: center;
    }
    .origin-station {
        /deep/ .icon {
            background: #06B880;
        }
        .station-name {
            &::before {
                background: #06B880;
            }
        }
    }

    .station-info {
        // padding: 0 52px;
        // margin-bottom: 24px;
        padding: 0 16px;
        .icon-change {
            color: #06B880;
            cursor: pointer;
            margin-top: 16px;
            display: inline-block;
        }
        .station-status {
            .status {
                margin: 0 24px 0 16px;
                display: inline-block;
                font-size: 12px;
                height: 24px;
                line-height: 24px;
                background: #06B880;
                border-radius: 12px;
                padding: 0 12px;
                color: #fff;
            }
            .abnormal {
                background: #ED4934;
            }
            .done {
                background: #C9CBCE;
            }
        }
        .station-name {
            font-size: 16px;
            position: relative;
            padding-left: 16px;
            &::before {
                content: '';
                width: 8px;
                height: 8px;
                border-radius: 50%;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .station-container {
            margin-top: 16px;
            justify-content: space-between;
            img {
                width: 16px;
                height: 16px;
            }
        }
    }
    .single-goods {
        background: #fff;
        padding: 24px;
    }

    .station-orders {
        margin-top: 16px;
        background: #F0F2F5;
        border: 1px solid #E6EAF0;
        border-radius: 4px;
        padding: 20px;
        color: #7E8694;
        // &.single-goods {
        //     margin: 0 32px;
        // }
        .order-info {
            justify-content: space-between;
            align-items: center;
            .order-info-container {
                flex: 3;
                &.staus-container {
                    flex: 1;
                }
                .info-order {
                    flex: 1;
                    margin-right: 16px;
                }
                p {
                    span {
                        color: #1C2026;
                        margin-top: 8px;
                    }
                }
            }
            .viewDetails {
                color: #06B880;
                cursor: pointer;
                margin-left: 12px;
            }
        }
        .action-button {
            margin-top: 20px;
            justify-content: space-between;
            .tag {
                display: inline-block;
                padding: 5px 12px;
                background: #E6EAF0;
                border: 1px solid #CDD2DA;
                border-radius: 2px;
                color: #505762;
                line-height: 22px;
                margin-right: 8px;
            }
            ::v-deep .ant-btn-link {
                padding: 0;
            }
        }
        .goods-table {
            margin-top: 16px;
            /deep/ .ant-table-thead > tr > th {
                background: #FAFBFC !important;
            }
            /deep/ .ant-table-tbody .ant-table-row  {
                background: #fff;
            }
        }
    }
    .icon-show {
        color: #606266;
        margin: 0 36px 0 8px;
        cursor: pointer;
    }
    .end-station{
        margin-top: 16px;
        /deep/ .icon {
            background: #FB9432;
        }
        .station-name {
            &::before {
                background: #FB9432;
            }
        }
    }
}
</style>
